<table class="table table-responsive-md  table-hover table-hover">
  <thead>
  <tr>
    <th scope="col" class="text-sm-start text-dark">ICD-10 Kodu</th>
    <th scope="col" class="text-sm-start text-dark">Açıklama</th>
    <th scope="col" class="text-sm-end text-dark">
      <button type="button" class="btn btn-warning btn-sm ms-2"
              (click)=" newHeadItem()">
        <i
          class="fas fa-add"></i>
      </button>
    </th>
  </tr>
  </thead>
  <tbody>
  <ng-container *ngIf="newMedicalRecordItem">
    <tr>
      <td>
        <p-dropdown
          [options]="icdCodeList"
          [(ngModel)]="newMedicalRecordData"
          [filter]="true"
          filterBy="label"
          optionLabel="label"
          optionValue="value"
          appendTo="body"
          (onChange)="onIcdCodeSelect($event)"
        ></p-dropdown>
      </td>
      <td>
        <input type="text" class="form-control form-control-sm" [(ngModel)]="newMedicalRecordData.description"
               placeholder="{{'general.description' | translate}}">
      </td>
      <td>
        <button class="btn btn-sm btn-primary float-right"
                (click)="addMedicalRecord(newMedicalRecordData)"
                [disabled]="!newMedicalRecordData.icdCodeId && !newMedicalRecordData.description"
        >{{ 'add' | translate }}
        </button>
      </td>
    </tr>
  </ng-container>

  <ng-container *ngFor="let item of medicalRecordItems; let i = index">
    <ng-container *ngIf="isEditing!=item; else editingRow">
      <tr>
        <td>{{ item?.icdCode }}</td>
        <td>{{ item?.icdCodeName }} *{{ item?.description}}</td>
        <td class="width-xs">
          <div class="dropdown c-pointer text-end">
            <div class="btn-link" data-bs-toggle="dropdown">
              <i class="fa-solid fa-ellipsis"></i>
            </div>
            <div class="dropdown-menu dropdown-menu-right">
              <a
                class="dropdown-item"
                href="javascript:void(0);"
                (click)="isEditing==item?isEditing=null:isEditing=item"
              >{{ "common.edit" | translate }}</a
              >
              <a
                class="dropdown-item"
                href="javascript:void(0);"
                (click)="deleteItem(i)"
              >{{ "common.delete" | translate }}</a
              >
            </div>
          </div>
        </td>
      </tr>
    </ng-container>
    <ng-template #editingRow>
      <tr>
        <td>
          <p-dropdown
            [options]="icdCodeList"
            [(ngModel)]="item.seleceted"
            [filter]="true"
            filterBy="label"
            optionLabel="label"
            optionValue="value"
            appendTo="body"
            (onChange)="onIcdCodeSelect($event)"
          ></p-dropdown>
        </td>
        <td>
          <input type="text" class="form-control form-control-sm" [(ngModel)]="item.description">
        </td>
        <td>
          <div class="float-right">
            <button type="button" class="btn btn-sm btn-warning btn-icon-xxs me-1"
                    (click)="saveItem(item)"
                    [disabled]="!item.icdCodeId && !item.description"
            ><i class="fas fa-save"></i></button>
            <button type="button" class="btn btn-sm btn-danger btn-icon-xxs"
                    (click)="isEditing==item?isEditing=null:isEditing=item"><i
              class="fas fa-close"></i></button>
          </div>
        </td>
      </tr>
    </ng-template>
  </ng-container>
  </tbody>
</table>
